import Swiper from "swiper";
import { Fancybox } from "@fancyapps/ui";
import { Navigation, Pagination } from "swiper/modules";

Fancybox.bind('[data-fancybox="slider-media"]');

const selectors = {
  slider: "[data-media]",
};

const initSwiper = (container) =>
  new Swiper(container.querySelector(".swiper"), {
    slidesPerView: "auto",
    spaceBetween: 24,

    breakpoints: {
      1024: {
        initialSlide: 1,
        centeredSlides: true,
        spaceBetween: 32,
      },
    },

    navigation: {
      prevEl: container.querySelector(".swiper-navigation.prev"),
      nextEl: container.querySelector(".swiper-navigation.next"),
    },

    pagination: {
      el: container.querySelector(".swiper-pagination"),
    },
  });

const init = (container) => {
  Swiper.use([Navigation, Pagination]);

  initSwiper(container);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const containers = document.querySelectorAll(selectors.slider);

    containers?.forEach(init);
  },
  {
    once: true,
  }
);
